import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Empty, Collapse, Image, Tooltip, Modal, DatePicker } from "antd";
import dayjs from "dayjs";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants, INVENTORY_RECIPE_TYPE, ROLES } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import RecipeDetailOptionComponent from "../../../component/inventory/recipe/RecipeDetailOptionComponent";
import { getOptionNames, getRecipeTypeLabel, getUniLabel, validateReadyFoodStockAdd } from "../../../services/inventory/recipe.service";
import CustomLoader from "../../../component/menu/CustomLoader";
import InventoryConfirmModal from "../../../component/inventory/InventoryConfirmModal";
import InventoryDependencyModal from "../../../component/inventory/InventoryDependencyModal";
import FoodTaxAndDiscountView from "../../../component/restaurants/foods/FoodTaxAndDiscountView";
import CustomModal from "../../../component/modals/CustomModal";
import CustomInputNumberV2 from "../../../component/CustomInputNumberV2";

export default function RecipeDetails() {
  const { user, showNotification, setNetworkCall, role } = useUserStore();
  const navigate = useNavigate();
  const [modal, contextHolder] = Modal.useModal();
  const { recipeId } = useParams();
  const { Panel } = Collapse;
  const [recipeLoading, setRecipeLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const recipeType = searchParams.get("recipeType");
  const variantId = searchParams.get("variantId") || "";
  const [recipe, setRecipe] = useState();
  const [recipeOptionsName, setRecipeOptionsName] = useState([]);
  const [recipeOptions, setRecipeOptions] = useState([]);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [chngStatusParamsObj, setChngStatusParamsObj] = useState({
    recipeType: "",
    recipeId: "",
    optionId: "",
    status: "",
  });
  const [openDependencyModal, setOpenDependencyModal] = useState(false);
  const [dependencyObj, setDependencyObj] = useState({
    dependentFoods: [],
    dependentOrders: [],
    dependentOrders: [],
  });
  const [openDelModal, setOpenDelModal] = useState(false);
  const [openDelDependencyModal, setOpenDelDependencyModal] = useState(false);
  const [selectedRecipeDeleteObj, setSelectedRecipeDeleteObj] = useState({
    recipeId: "",
    recipeType: "",
    optionId: "",
  });
  const [openStockAddModal, setOpenStockAddModal] = useState(false);
  const [stockInputs, setStockInputs] = useState({
    optionId: '',
    itemQuantity: '',
    date: '',
    unitPrice: ''
  });

  async function getRecipeDetails(params) {
    if (!params?.recipeId || !params?.recipeType) {
      console.error("Recipe id and type are required for getting recipe details.");
      return false;
    }

    try {
      setNetworkCall(true);
      const res = await ApiService.GET_INVENTORY_RECIPE_DETAIL(params, user.token.token);
      if (res.code !== 200) {
        showNotification(res.data.message);
        return false;
      }

      const { record } = res.payload;
      const { options } = record;

      setRecipeOptionsName(getOptionNames(options));
      setRecipe(record);
      setRecipeOptions(options);

      return options.length === 0;
    } catch (err) {
      showNotification(err?.response?.data?.message || "Something went wrong");
      return false;
    } finally {
      setNetworkCall(false);
      setRecipeLoading(false);
    }
  }

  function onHandleChangeRecipeOption(recipeOptionId, recipeOptionStatus) {
    setOpenStatusModal(true);
    const params = {
      recipeType: recipe.recipeType,
      recipeId: recipe.id,
      optionId: recipeOptionId,
      status: recipeOptionStatus === "Active" ? "Inactive" : "Active",
    };
    setChngStatusParamsObj(params);
  }

  async function confirmChangeRecipeStatus(params) {
    setNetworkCall(true);
    try {
      const res = await ApiService.INVENTORY_RECIPE_STATUS_CHANGE_CONFIRM(params, user.token.token);
      if (!res || res.code !== 200) {
        setOpenDependencyModal(false);
        setNetworkCall(false);
        setChngStatusParamsObj({});
        showNotification(res.message);
        return;
      }
      showNotification(`Variant ${chngStatusParamsObj.status.toLowerCase()} successfully!`, false);
      getRecipeDetails({ recipeId, recipeType });
      setChngStatusParamsObj({});
      setNetworkCall(false);
      return;
    } catch (err) {
      setNetworkCall(false);
      showNotification(err.response?.data?.message);
      return false;
    }
  }

  async function changeRecipeStatus(params) {
    setNetworkCall(true);
    try {
      const res = await ApiService.INVENTORY_RECIPE_STATUS_CHANGE(params, user.token.token);
      if (!res || res.code !== 200) {
        setNetworkCall(false);
        showNotification(res.message);
        setChngStatusParamsObj({});
        return;
      }
      const { payload } = res;
      const { success, dependentFoods, dependentSetMenus, dependentOrders } = payload;

      // When success is false
      if (!success) {
        setNetworkCall(false);
        setOpenDependencyModal(true);
        setDependencyObj({ dependentFoods, dependentSetMenus, dependentOrders });
        return;
      }
      showNotification(`Variant ${params.status.toLowerCase()} successfully!`, false);
      setChngStatusParamsObj({});
      setNetworkCall(false);
      getRecipeDetails({ recipeId, recipeType });
      return;
    } catch (err) {
      setNetworkCall(false);
      showNotification(err.response?.message);
      return false;
    }
  }

  async function onHandleConfirmOptionStatus() {
    setOpenStatusModal(false);
    changeRecipeStatus(chngStatusParamsObj);
  }

  function onCloseConfirmOptionStatusModal() {
    setOpenStatusModal(false);
  }

  function onHandleConfirmChangeStatusForcefully() {
    if (
      dependencyObj.dependentOrders.length > 0 &&
      dependencyObj.dependentFoods.length < 1 &&
      dependencyObj.dependentSetMenus.length < 1
    ) {
      showNotification("Sorry We can not change the recipe status for order dependency.");
      setDependencyObj({});
      setOpenDependencyModal(false);
      return;
    }
    const params = {
      recipeType: recipe.recipeType,
      recipeId: recipe.id,
      optionId: chngStatusParamsObj.optionId,
      dependentFoods: [...dependencyObj.dependentFoods.map((item) => item.id)],
      dependentSetMenus: [...dependencyObj.dependentSetMenus.map((item) => item.id)],
      dependentOrders: [...dependencyObj.dependentOrders.map((item) => item.id)],
    };
    confirmChangeRecipeStatus(params);
  }

  async function deleteRecipe(params) {
    if (!params) return;
    setNetworkCall(true);
    try {
      const res = await ApiService.INVENTORY_RECIPE_DELETE(params, user.token.token);
      if (!res || res.code !== 200) {
        setNetworkCall(false);
        setSelectedRecipeDeleteObj({});
        showNotification(res.data.message);
        return;
      }
      const { payload } = res;
      const { success, dependentFoods, dependentSetMenus, dependentOrders } = payload || {};
      if (success === false) {
        setOpenDelModal(false);
        setNetworkCall(false);
        setDependencyObj({ dependentFoods, dependentSetMenus, dependentOrders });
        setOpenDelDependencyModal(true);
        return;
      }

      setOpenDelModal(false);
      setNetworkCall(false);
      setSelectedRecipeDeleteObj({});
      const isRecipeOptionsZero = await getRecipeDetails({ recipeId, recipeType });
      if (isRecipeOptionsZero) {
        navigate("/inventory/recipe");
        showNotification("Recipe deleted successfully.", false);
        return;
      }
      showNotification("Recipe deleted successfully.", false);
    } catch (err) {
      setNetworkCall(false);
      showNotification(err.response.data.message);
      return;
    }
  }

  // delete with dependency
  async function deleteRecipeWithDependencyConfirmation(params) {
    if (!params) return;
    setNetworkCall(true);
    try {
      const res = await ApiService.INVENTORY_RECIPE_DELETE_CONFIRM(params, user.token.token);
      if (!res || res.code !== 200) {
        setNetworkCall(false);
        showNotification(res.message);
        setSelectedRecipeDeleteObj({});
        setDependencyObj({});
        setOpenDelDependencyModal(false);
        return;
      }
      setSelectedRecipeDeleteObj({});
      setDependencyObj({});
      setOpenDelDependencyModal(false);
      setNetworkCall(false);
      const isRecipeOptionsZero = await getRecipeDetails({ recipeId, recipeType });
      if (isRecipeOptionsZero) {
        navigate("/inventory/recipe");
        showNotification("Recipe deleted with dependency successfully.", false);
        return;
      }
      showNotification("Recipe deleted with dependency successfully.", false);
    } catch (err) {
      setNetworkCall(false);
      showNotification(err.response.message);
      return;
    }
  }

  function onHandleDeleteRecipeVariant(recipeId, recipeType, optionId) {
    if (role === ROLES.STAFF) {
      showNotification("You are not authorize to delete this ingredient.");
      return;
    }
    setOpenDelModal(true);
    setSelectedRecipeDeleteObj({ recipeId, recipeType, optionId });
  }

  function onHandleConfirmRecipeOpDel() {
    setOpenDelModal(false);
    deleteRecipe(selectedRecipeDeleteObj);
  }

  function onHandleCancelRecipeOpDel() {
    setOpenDelModal(false);
  }

  function onClickStockAdd(targetOptionId) {
    setOpenStockAddModal(true);
    setStockInputs((prev) => ({
      ...prev,
      optionId: targetOptionId,
      itemQuantity: '',
      date: '',
      unitPrice: ''
    }))
  }

  function onHandleStockDate(date, dateString) {
    setStockInputs((prev) => ({
      ...prev,
      date: dateString
    }));
  }

  async function handleStockAdd() {
    try {
      const errorMsg = validateReadyFoodStockAdd(stockInputs);

      if (errorMsg) {
        showNotification(errorMsg);
        return;
      }

      setNetworkCall(true);
      const params = {...stockInputs, restaurantId: recipe.restaurantId, recipeId: recipe.id};

      const res = await ApiService.INVENTORY_READY_FOOD_STOCK_ADD(params, user.token.token);
      
      if (!res || res.code !== 200) {
        showNotification(res.message);
        return;
      }

      showNotification("Stock updated successfully.", false);
      setOpenStockAddModal(false);
    } catch (err) {
      showNotification(err.response?.message || "Faild to update stock. Please try again.");
    } finally {
      setNetworkCall(false);
    }
  }

  async function onHandleDeleteConfirmWithDependency() {
    if (
      dependencyObj?.dependentOrders?.length > 0 &&
      dependencyObj?.dependentFoods?.length < 1 &&
      dependencyObj?.dependentSetMenus?.length < 1
    ) {
      showNotification("Sorry We can not delete the recipe forcefully for order dependency.");
      setOpenDelDependencyModal(false);
      setSelectedRecipeDeleteObj({});
      setDependencyObj({});
      return;
    }
    const params = {
      recipeType: selectedRecipeDeleteObj.recipeType,
      recipeId: selectedRecipeDeleteObj.recipeId,
      optionId: selectedRecipeDeleteObj.optionId,
      dependentFoods: [...dependencyObj.dependentFoods.map((item) => item.id)],
      dependentSetMenus: [...dependencyObj.dependentSetMenus.map((item) => item.id)],
      dependentOrders: [...dependencyObj.dependentOrders.map((item) => item.id)],
    };
    await deleteRecipeWithDependencyConfirmation(params);
  }

  useEffect(() => {
    if (Boolean(recipeId) && Boolean(recipeType)) {
      const params = { recipeId, recipeType, optionId: variantId };
      getRecipeDetails(params);
    }
  }, [recipeId, recipeType, variantId]);

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_5"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent title={"Recipe Details"} listRoute="/inventory/recipe" />
          </div>

          <div className="flex items-center justify-center">
            <div className="w-[1011px] h-auto min-h-[50vh] rounded-[12px] pt-[30px] pl-[37px] pr-[44px] pb-[100px]">
              {!recipeLoading && !Boolean(recipe) ? (
                <div className="h-[50vh] flex items-center justify-center">
                  <Empty />
                </div>
              ) : (
                <div className="w-full h-full">
                  <div className="flex items-center justify-between mb-5">
                    <div className="text-sm font-p_medium text-black leading-[13px] flex flex-col gap-y-[10px] w-[calc(100%-124px)] break-all">
                      <p>
                        Recipe Type: <span className="font-p_semibold">{getRecipeTypeLabel(recipe?.recipeType)}</span>
                      </p>
                      <p>
                        Recipe Name: <span className="font-p_semibold">{recipe?.name}</span>
                      </p>
                      <p>
                        Category: <span className="font-p_semibold">{recipe?.category.name}</span>
                      </p>
                      <p>
                        Food Description:{" "}
                        <span className="font-p_semibold leading-[22px] overflow-hidden break-words">
                          {recipe?.details}
                        </span>
                      </p>

                      <FoodTaxAndDiscountView
                        data={{
                          isVatApplicable: recipe?.isVatApplicable,
                          isDiscountApplicable: recipe?.isDiscountApplicable,
                          isSupplementaryDutyApplicable: recipe?.isSupplementaryDutyApplicable,
                          supplementaryDuty: Number(recipe?.supplementaryDuty || 0),
                        }}
                      />
                    </div>
                    <div className="w-[104px] h-[104px] recipe-detail-img">
                      <img src={recipe?.image || "/logo.png"} className="w-full h-full rounded-[8px]" />
                    </div>
                  </div>

                  {((Boolean(recipe?.addOns) && recipe?.addOns.length > 0) ||
                    (Boolean(recipe?.additionGroups) && recipe?.additionGroups.length > 0)) && (
                    <div>
                      <div className="w-full flex items-center justify-between mb-[28px]">
                        {recipe?.addOns.length > 0 && (
                          <div className="w-[40%] flex items-center">
                            <h1 className="font-p_medium text-black text-[16px]">Add-Ons</h1>
                            <div className="ml-3 flex-1 border-t border-gray-300"></div>
                          </div>
                        )}
                        {recipe?.additionGroups.length > 0 && (
                          <div className="w-[40%] flex items-center">
                            <h1 className="font-p_medium text-black text-[16px]">Meal Addition</h1>
                            <div className="ml-3 flex-1 border-t border-gray-300"></div>
                          </div>
                        )}
                      </div>
                      <div className="w-full flex items-start justify-between min-h-[100px]">
                        {/* add-ons */}
                        {recipe?.addOns.length > 0 && (
                          <div className="w-[40%] h-full">
                            {recipe?.addOns.map((addOn) => (
                              <div key={addOn.addOnId} className="w-full flex items-center space-x-[6px] mb-[5px]">
                                <div className="w-[10px] h-[10px] bg-[#FCBD10] rounded-full"></div>
                                <div className="w-[70%] font-p_regular text-[14px] text-[#341557] flex items-center justify-between">
                                  <h1 className="max-w-[150px] break-words">{addOn.name}</h1>
                                  <p>{addOn.price} TK</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* addition items */}
                        {recipe?.additionGroups.length > 0 && (
                          <div className="w-[40%] h-full inventory-recipe-details-addition">
                            <Collapse
                              accordion
                              expandIconPosition="end"
                              expandIcon={({ isActive }) =>
                                isActive ? (
                                  <Image src="/images/icons/addition_expand.svg" preview={false} />
                                ) : (
                                  <Image src="/images/icons/addition_collapse.svg" preview={false} />
                                )
                              }
                              ghost
                            >
                              {recipe?.additionGroups.map((additionGrp) => (
                                <Panel
                                  key={additionGrp.additionGroupId}
                                  header={
                                    <div className="flex items-center justify-between w-full h-[21px]">
                                      <div className="min-w-[150px] flex items-center space-x-[6px]">
                                        <div className="w-[10px] h-[10px] bg-[#FCBD10] rounded-full"></div>
                                        <Tooltip title={additionGrp.name}>
                                          <span className="font-p_regular text-[14px] text-[#341557] truncate max-w-[150px]">
                                            {additionGrp.name}
                                          </span>
                                        </Tooltip>
                                      </div>
                                      <div className="font-p_regular text-[14px] text-[#341557] pr-5">
                                        {additionGrp.pricePerAddition} TK
                                      </div>
                                    </div>
                                  }
                                >
                                  <ul className="pl-6 list-disc min-w-0">
                                    {additionGrp.additionItems.map((item) => (
                                      <li
                                        key={item.additionItemId}
                                        className="text-[13px] text-gray-700 leading-[20px] cursor-default whitespace-normal break-words"
                                      >
                                        {item.name}
                                      </li>
                                    ))}
                                  </ul>
                                </Panel>
                              ))}
                            </Collapse>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ingredients and its costs */}
                  <div className="mt-[33px]">
                    {recipeOptions.length > 0 &&
                      recipeOptions.map((recipeOption) => (
                        <div key={recipeOption.optionId} className="mb-5">
                          <div className="font-semibold mb-1 flex items-center justify-between">
                            <span className="max-w-[800px] break-all">
                              {["System Default", "Default"].includes(recipeOption.name) ||
                              ["ADDITION_ITEM", "ADD_ONS"].includes(recipeType)
                                ? ""
                                : recipeOption.name}
                            </span>
                            <div className="flex items-center space-x-[15px]">
                              {recipe.readyFoodType !== 'RECIPE' &&
                              <button
                                className="text-base font-p_medium leading-[13px] rounded-[5px] text-white bg-[#2EC114] h-[42px] w-[100px]"
                                onClick={() => onClickStockAdd(recipeOption.optionId)}
                              >
                                Add Stock
                              </button>
                              }
                              <button
                                onClick={() => onHandleChangeRecipeOption(recipeOption.optionId, recipeOption.status)}
                                className="w-[43px] h-[43px]"
                              >
                                {recipeOption.status === "Active" ? (
                                  <Tooltip placement="top" title="Deactivate Recipe?">
                                    <Image src="/images/tickicon.svg" preview={false} />
                                  </Tooltip>
                                ) : (
                                  <Tooltip placement="top" title="Activate Recipe?">
                                    <Image src="/images/tickicongrey.svg" preview={false} />
                                  </Tooltip>
                                )}
                              </button>
                              <button
                                className="w-[38px] h-[38px] bg-[#FCBD10] rounded-full flex items-center justify-center"
                                onClick={() => onHandleDeleteRecipeVariant(recipeId, recipeType, recipeOption.optionId)}
                              >
                                <Image src="/images/icons/delete.svg" preview={false} alt="delete" />
                              </button>
                            </div>
                          </div>
                          <RecipeDetailOptionComponent option={recipeOption} />
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <CustomModal
        isCustomModalOpen={openStockAddModal}
        onCancel={() => setOpenStockAddModal(false)}
        onOk={handleStockAdd}
        title="Update Stock for Ready Food"
        subTitle=""
        okText="Update"
        width={600}
      >
        <div className="text-sm text-red-600">All fields are required</div>
        <div className="flex items center gap-2 mt-5 mb-10">
          <div className="w-[200px] h-[48px]">
            <CustomInputNumberV2
              name="stockQuantity"
              value={stockInputs.itemQuantity}
              setValue={(val) => setStockInputs(prev => ({...prev, itemQuantity: val}))}
              max={99999}
              min={1}
              placeholder={"Stock Amount"}
              addonAfter={getUniLabel(recipe?.unit || '')}
            />
          </div>
          <div className="w-[200px] h-[48px]">
            <CustomInputNumberV2
              name="unitPrice"
              value={stockInputs.unitPrice}
              setValue={(val) => setStockInputs(prev => ({...prev, unitPrice: val}))}
              max={99999}
              min={0}
              isDecimalAllowed={true}
              placeholder={""}
              addonBefore="Unit Price"
            />
          </div>
        <div className="w-[160px]">
          <DatePicker
            className={" w-full"}
            showTime={false}
            onChange={onHandleStockDate}
            placeholder="Stock Date"
            value={stockInputs.date ? dayjs(stockInputs.date) : null}
            // disabledDate={(current) => current && current > dayjs().endOf("day")}
            disabledDate={(current) => {
              if (!current) return false;
              const today = dayjs().endOf("day");
              const sevenDaysAgo = dayjs().subtract(6, "day").startOf("day");
              return current < sevenDaysAgo || current > today;
            }}
          />
        </div>
        </div>
      </CustomModal>

      {/* change status modals */}
      <InventoryConfirmModal
        open={openStatusModal}
        title="Are you sure?"
        message="This will change the status of the recipe's option"
        onConfirm={onHandleConfirmOptionStatus}
        onCancel={onCloseConfirmOptionStatusModal}
      />
      {(dependencyObj?.dependentFoods?.length > 0 ||
        dependencyObj?.dependentSetMenus?.length > 0 ||
        dependencyObj?.dependentOrders?.length > 0) && (
        <InventoryDependencyModal
          open={openDependencyModal}
          title="Are you sure want to change the recipe status forcefully!"
          dependentFoods={dependencyObj.dependentFoods}
          dependentSetMenus={dependencyObj.dependentSetMenus}
          dependentOrders={dependencyObj.dependentOrders}
          handleConfirm={onHandleConfirmChangeStatusForcefully}
          handleCancel={() => setOpenDependencyModal(false)}
        />
      )}

      {/* delete modals */}
      <InventoryConfirmModal
        open={openDelModal}
        title="Are you sure?"
        message="This will delete the recipe's option!"
        onConfirm={onHandleConfirmRecipeOpDel}
        onCancel={onHandleCancelRecipeOpDel}
      />
      {(dependencyObj?.dependentFoods?.length > 0 ||
        dependencyObj?.dependentSetMenus?.length > 0 ||
        dependencyObj?.dependentOrders?.length > 0) && (
        <InventoryDependencyModal
          open={openDelDependencyModal}
          title="Are you sure want to delete the recipe status forcefully!"
          dependentFoods={dependencyObj.dependentFoods}
          dependentSetMenus={dependencyObj.dependentSetMenus}
          dependentOrders={dependencyObj.dependentOrders}
          handleConfirm={onHandleDeleteConfirmWithDependency}
          handleCancel={() => setOpenDelDependencyModal(false)}
        />
      )}
      {contextHolder}
    </div>
  );
}
